import { useEffect, useRef, useState } from "react";
import { auth } from "integrations/firebase/auth";
import { useTranslation } from "react-i18next";
import { useSignInWithEmailLink } from "react-firebase-hooks/auth";
import { toast } from "utils/toast";
import { useAnalytics } from "contexts/AnalyticsContext";
import { Loader } from "components/loading/Loader";
import { Header } from "components/layout";
import { Text } from "components/text";
import { LoginLinkError } from "./components/LoginLinkError";

export function LoginLink() {
  const { gaEvent } = useAnalytics();
  const { t } = useTranslation("login");
  const processingRef = useRef(false);
  const [emailMissing, setEmailMissing] = useState(false);

  const [signInWithEmailLink, user, , error] = useSignInWithEmailLink(auth);

  useEffect(() => {
    if (processingRef.current || auth.currentUser) {
      return;
    }

    const email = window.localStorage.getItem("emailForSignIn");
    if (!email) {
      // reports a missing localStorage email precondition on mount before returning without starting email-link sign-in
      setEmailMissing(true);
      return;
    }

    processingRef.current = true;

    signInWithEmailLink(email).then(() => {
      window.localStorage.removeItem("emailForSignIn");
    });
  }, [signInWithEmailLink]);

  // Navigating here would beat the session load and bounce off the _app guard;
  // the _auth route guard sends the user home once the session exists.
  useEffect(() => {
    if (!user) {
      return;
    }

    gaEvent({ type: "login_request", payload: { method: "link" } });
    toast.success(t("login:success.toast.title"));
  }, [user, gaEvent, t]);

  if (emailMissing || error) {
    return <LoginLinkError error={error} />;
  }

  return (
    <div className="flex flex-col space-y-8 h-full items-center justify-center">
      <Loader />
      <Text as="div" variant="pageHeading">
        {t("login:link.loading")}
      </Text>
    </div>
  );
}

export function LoginLinkPage() {
  return (
    <div className="h-full flex w-full flex-col">
      <Header className="fixed" />

      <div className="flex-1">
        <LoginLink />
      </div>
    </div>
  );
}
